import { MapControls } from '@/components/MapControls'

import { Map } from './components/Map'
import { OrdersRoot } from './form/OrdersRoot'

import { Box, Stack } from '@mui/material'

export function Orders() {
  return (
    <Stack direction="row" height="100%" width="100%" data-testid="orders-root">
      <OrdersRoot />
      <Box width="100%" height="100%" flex="0 1 auto">
        <Stack direction="column" height="100%" width="100%">
          <MapControls />
          <Map />
        </Stack>
      </Box>
    </Stack>
  )
}
